import { Link } from "react-router-dom";
import Company from "../utilities/Company";
import Flexbox from "./Flexbox";
import Grid from "./Grid";
import Spacebox from "./Spacebox";
import { Divider } from "@mui/material";
import { isMobile } from "react-device-detect";

const Footer = () => {
    return (
        <div className="footer" style={{ padding: isMobile ? '20px' : '40px 80px', borderTop: '1px solid #4A3FFF20' }}>
            <Grid grid={isMobile ? 1 : 5} gap="20px">
                <div>
                    <img src="/assets/logo.png" alt="logo" style={{ width: '90px' }} />
                    <Spacebox padding="10px" />
                    <small style={{ opacity: .6 }}>
                        Empowering businesses with fast, flexible funding solutions for sustainable growth.
                    </small>
                    <Spacebox padding="10px" />
                    <Flexbox alignItems="center" >
                        <a href="https://facebook.com/fundgenies" target="_blank" rel="noreferrer">
                            <img style={{ width: '18px', opacity: .6 }} src="/svgs/facebook.svg" alt="facebook" />
                        </a>
                        <Spacebox padding="10px" />
                        <a href="https://www.linkedin.com/in/cedrick-williams-678796249" target="_blank" rel="noreferrer">
                            <img style={{ width: '18px', opacity: .6 }} src="/svgs/linkedin.svg" alt="linkedin" />
                        </a>
                        <Spacebox padding="10px" />
                        <a href="https://www.facebook.com/Brightstarrconsultant" target="_blank" rel="noreferrer">
                            <img style={{ width: '18px', opacity: .6 }} src="/svgs/instagram.svg" alt="instagram" />
                        </a>
                    </Flexbox>
                </div>
                <div>
                    <span>
                        <b>Company</b>
                    </span>
                    <Spacebox padding="20px" />
                    <Link to="/about">
                        <span style={{ opacity: .6 }}>About Us</span>
                    </Link>
                    <Spacebox padding="10px" />
                    <Link to="/contact">
                        <span style={{ opacity: .6 }}>Contact</span>
                    </Link>
                    <Spacebox padding="10px" />
                    <Link to="/career">
                        <span style={{ opacity: .6 }}>Careers</span>
                    </Link>
                </div>
                <div>
                    <span>
                        <b>Resources</b>
                    </span>
                    <Spacebox padding="20px" />
                    <Link to="/faq">
                        <span style={{ opacity: .6 }}>FAQ</span>
                    </Link>
                    <Spacebox padding="10px" />
                    <Link to="/terms">
                        <span style={{ opacity: .6 }}>Terms</span>
                    </Link>
                    <Spacebox padding="10px" />
                    <Link to="/privacy">
                        <span style={{ opacity: .6 }}>Privacy</span>
                    </Link>
                </div>
                <div>
                    <span>
                        <b>Contact Us</b>
                    </span>
                    <Spacebox padding="20px" />
                    <span style={{ opacity: .6 }}>{Company.email}</span>
                </div>
                <div></div>
            </Grid>
            <Spacebox padding="20px" />
            <Divider style={{ opacity: .6 }} />
            <Spacebox padding="20px" />
            <small style={{ opacity: .6 }}>
                © {(new Date()).getFullYear()} BrightStarr Consulting. All rights reserved.
            </small>
        </div>
    );
}

export default Footer;